export default __webpack_public_path__ + "static/media/portfolio-39.aad90298.jpg";